import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)
import * as api from '../utils/api'
export default new Vuex.Store({
  state: {
    a_index: -1,
    token: localStorage.getItem('token'),
    personInfo: {},
    s_index: 0,
    service: '',
    breadList: [
      {
        title: '首页',
        path: '/'
      }
    ],
    navList: [
      {
        title: '首页',
        href: '/'
      },
      {
        title: '通知公告',
        href: '/noticeList'
      },
      {
        title: '政策法规',
        href: '/policyList'
      },
      {
        title: '职教资讯',
        href: '/newsInfo'
      },
      {
        title: '公共资源',
        href: '/resourceSearch?type=5',
        name: '资源中心'
      }, {
        title: '院校资源',
        href: '/schoolList',
        name: '院校资源'
      },
      {
        title: '名师讲堂',
        href: '/teachHall'
      },

      {
        title: '帮助中心',
        href: '/helpCenter'
      },
      {
        title: '关于我们',
        href: '/aboutDetail'
      }
    ],
    resouceType: ['资源分类', '专业类别', '资源类型', '资源大类'],
    schoolList: {},
    competitiveList: {},
    hotList: {},
    newList: {}
  },
  getters: {
    breadList: state => state.breadList,
    a_index: state => state.a_index,
    navList: state => state.navList,
    resouceType: state => state.resouceType,
    token: state => state.token,
    personInfo: state => state.personInfo,
    s_index: state => state.s_index,
    schoolList: state => state.schoolList,
    competitiveList: state => state.competitiveList,
    hotList: state => state.hotList,
    newList: state => state.newList,
    service: state => state.service
  },
  mutations: {
    set_nav_index(state, index) {
      localStorage.setItem('a_index', index)
      state.a_index = localStorage.getItem('a_index')
    },
    set_service(state, data) {

      state.service = data
    },
    set_token(state, token) {
      localStorage.setItem('token', token)
      state.token = localStorage.getItem('token')
    },
    set_index(state, data) {
      state.s_index = data
    },
    set_user_info(state, data) {
      state.personInfo = data
    },
    addBread(state, route) {
      state.breadList.push(route)
    },
    spliceBread(state, num) {
      state.breadList.splice(num.index, num.snum)
    },
    setSchoolInfo(state, data) {
      state.schoolList = data
    },
    setCompetitivelist(state, data) {
      state.competitiveList = data
    },
    setHotlist(state, data) {
      state.hotList = data
    },
    setNewlist(state, data) {
      state.newList = data
    }
  },
  actions: {
    getSchoolList({ commit }, params) {
      api.getSchoolList(params).then(res => {
        commit('setSchoolInfo', res.data)
      })
    },
    getPlatformIndexList({ commit }, params) {
      // 获取首页展示的资源列表
      api.getPlatformIndexList(params).then(res => {
        if (params.category === 'competitive') {
          commit('setCompetitivelist', res.data)
        } else if (params.category === 'hot') {
          commit('setHotlist', res.data)
        } else {
          commit('setNewlist', res.data)
        }
      })
    }
  },
  modules: {
  }
})
